import { makeAutoObservable, runInAction } from "mobx";

import { dialogsService } from "../api/dialogsService";
import {
  IDeleteDialogParams,
  IDialog,
  IGetDialogsParams,
  IHistoryDialog,
  ISearchDialogsParams,
} from "../types";

export class DialogsStore {
  activeDialog: IDialog | null = null;
  activeDialogId: string | null = null;
  dialogs: IHistoryDialog[] = [];
  searchedDialogs: IHistoryDialog[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setActiveDialog(dialog: IDialog | null) {
    this.activeDialog = dialog;
  }

  setActiveDialogId(dialogId: string | null) {
    this.activeDialogId = dialogId;
  }

  clearSearchedDialogs() {
    this.searchedDialogs = [];
  }

  async getDialog(id: string) {
    const response = await dialogsService.getDialog(id);

    runInAction(() => {
      this.activeDialog = response;
    });

    return response;
  }

  async getDialogs(params: IGetDialogsParams) {
    const response = await dialogsService.getDialogs({ ...params, limit: 100 });

    runInAction(() => {
      this.dialogs = response.data;
    });
  }

  async searchDialogs(params: ISearchDialogsParams) {
    const response = await dialogsService.searchDialogs({
      ...params,
      limit: 100,
    });

    runInAction(() => {
      this.searchedDialogs = response.data;
    });
  }

  async deleteDialog(params: IDeleteDialogParams) {
    await dialogsService.deleteDialog(params);
    this.dialogs = this.dialogs.filter((d) => d.dialog_id !== params.dialog_id);
  }
}
